export default "__VITE_ASSET__x6s1yQ1k__"